import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { FIREBASE_CLIENT_CONFIG } from '@shared/config';

// Initialize Firebase
const app = initializeApp(FIREBASE_CLIENT_CONFIG);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app, FIREBASE_CLIENT_CONFIG.databaseId || '(default)');
